<template>
    <div class="">
        <div class="grid grid-cols-40/60 lg:grid-cols-1/3 1.5xl:grid-cols-1/4 h-subnav mt-8 mb-2"
             :class="{'hidden':activeProduct || activeDecor ||activePackaging}"
             v-show="!activeProduct && !activeDecor && !activePackaging">

            <div class="title flex justify-end items-center gap-x-4 pl-2">
                <button v-if="canSeeArticle()"
                        @click="changeToProducts" class="subnav classen__button"
                        :class="{'classen__button_active':activeTab===0}">
                    <p class="title leading-none">{{ getTranslation('articles') }}</p>
                </button>
                <button v-if="canSeeDecor()"
                        @click="changeToDecors" class="subnav classen__button"
                        :class="{'classen__button_active':activeTab===1}">
                    <p class="title leading-none">{{ getTranslation('decor') }}</p>
                </button>
                <button v-if="canSeePackaging()"
                        @click="activeTab=2" class="subnav classen__button"
                        :class="{'classen__button_active':activeTab===2}">
                    <p class="title leading-none">{{ getTranslation('packaging') }}</p>
                </button>
            </div>

            <div class="grid pl-0 pr-10 1.5xl:pl-20 1.5xl:pr-20"
                 :class="{'grid-cols-13': !menuOpened, 'grid-cols-12': menuOpened}">
                <!-- TODO: grid-cols-13 back to grid-cols-12 when re-enabling camera -->
                <div
                    class="mr-2 flex col-span-9 lg:col-span-11 justify-end items-center w-full h-full gap-2"
                    v-if="menuOpened">
                    <button v-if="activeTab===0"
                            @click="isUploadExcelVisible = true"
                            class="actionButton classen__button hover__button">
                        <p class="leading-none">{{ getTranslation('uploadExcel') }}</p>
                    </button>
                    <button v-if="activeTab===0"
                            @click="updateBound()" :class="{'classen__button_active':selected==='bound'}"
                            class="actionButton classen__button hover__button">
                        <p class="leading-none" v-if="inbound">
                            {{ getTranslation('goToInBoundProducts') }}
                        </p>
                        <p class="leading-none" v-if="!inbound">
                            {{ getTranslation('goToOutBoundProducts') }}
                        </p>
                    </button>
                    <button v-if="activeUserHasRole(ROLES.MASTER_ADMIN)" @click="updateActive()"
                            :class="{'classen__button_active':selected==='active'}"
                            class="actionButton classen__button hover__button">
                        <p class="leading-none" v-if="!inactive">
                            <template v-if="activeTab===0">{{ getTranslation('goToActiveProducts') }}</template>
                            <template v-if="activeTab===1">{{ getTranslation('goToActiveDecors') }}</template>
                        </p>
                        <p class="leading-none" v-if="inactive">
                            <template v-if="activeTab===0">{{ getTranslation('goToInactiveProducts') }}</template>
                            <template v-if="activeTab===1">{{ getTranslation('goToInactiveDecors') }}</template>
                        </p>
                    </button>
                </div>
                <!-- TODO: replace css by col-start-10 col-span-3 lg:col-start-12 flex -->
                <div class="flex justify-end">
                    <div v-if="activeTab===0 || (activeTab===1 && activeUserHasRole(ROLES.MASTER_ADMIN))"
                         class="menuBurger cursor-pointer"
                         @click="menuOpened=!menuOpened">
                        <div v-show="!menuOpened">
                            <label>
                                <i class="fas fa-bars"></i>
                            </label>
                        </div>
                        <div v-show="menuOpened">
                            <label>
                                <i class="fas fa-times"></i>
                            </label>
                        </div>
                    </div>
                    <!-- TODO: re-enable -->
                    <div v-if="false" :class="{'alone': activeTab===2}"
                         class="bg-classen__primary flex justify-center items-center camera-div">
                        <img class="bottom-5 cursor-pointer" src="../assets/icons/camera.svg"
                             @click="showQrReader = true"/>
                    </div>
                </div>
            </div>
        </div>

        <c-products v-if="activeTab===0 && canStartLoading" class="h-subnav-remain"
                    @selectionChanged="changedProductSelection"
                    :class="{'hidden':activeProduct || activeDecor || activePackaging}"
                    @resetFilters="reset"/>
        <c-decors v-if="activeTab===1 && canStartLoading" class="h-subnav-remain"
                  :class="{'hidden':activeProduct || activeDecor || activePackaging}"/>
        <c-packagings v-if="activeTab===2 && canStartLoading" class="h-subnav-remain"
                      :class="{'hidden':activeProduct || activeDecor || activePackaging}"/>

        <c-product-detail id="prod_detail" class="h-full w-full" @close="closeProduct"
                          :product="activeProduct"
                          :activeSelection="activeProductSelection"
                          v-if="activeProduct"></c-product-detail>
        <c-decor-detail id="dec_detail" class="h-full" @close="closeDecor"
                        :activeSelection="activeDecorSelection"
                        :decor="activeDecor" v-if="activeDecor"/>

        <c-packaging-detail id="pac_detail" class="h-full" @close="closePackaging"
                            :packaging="activePackaging"
                            v-if="activePackaging"/>

        <c-upload-excel v-if="isUploadExcelVisible" @close="isUploadExcelVisible = false"/>

        <c-qr-reader-popup v-if="showQrReader" @close="showQrReader = false"/>
    </div>
</template>

<script>
import Vue from "vue";
import Products from "../components/structure/Products/Products";
import Decors from "../components/structure/Decors/Decors";
import Packagings from "../components/structure/Packaging/Packagings";
import getTranslation from "../mixins/getTranslation";
import ProductDetail from "../components/structure/Products/ProductDetail";
import EventBus from "../services/EventBus";
import DecorDetail from "../components/structure/Decors/DecorDetail";
import PackagingDetail from "../components/structure/Packaging/PackagingDetail";
import getPermissions from "../mixins/getPermissions";
import PopupUploadExcel from "../components/structure/PopupUploadExcel";
import QrReaderPopup from "../components/form/QrReaderPopup";

export default {
    name: "ArticlesDecorsPackagingLandingPage",

    mixins: [getTranslation, getPermissions],

    components: {
        'c-products': Products,
        'c-decors': Decors,
        'c-packagings': Packagings,
        'c-product-detail': ProductDetail,
        'c-decor-detail': DecorDetail,
        'c-packaging-detail': PackagingDetail,
        'c-upload-excel': PopupUploadExcel,
        'c-qr-reader-popup': QrReaderPopup
    },

    data() {
        return {
            activeTab: 0,
            inbound: true,
            inactive: true,
            menuOpened: false,
            activeProduct: null,
            activeDecor: null,
            selected: 'active',
            activePackaging: null,
            activeProductSelection: null,
            activeDecorSelection: null,
            skipNext: false,
            lastSteps: [],
            isUploadExcelVisible: false,
            canStartLoading: false,
            showQrReader: false,
        }
    },

    watch: {
        activeTab() {
            if (this.activeTab === 0) {
                document.title = 'The Qube - Articles';
                return;
            }

            if (this.activeTab === 1) {
                document.title = 'The Qube - Decors';
                return;
            }

            if (this.activeTab === 2) {
                document.title = 'The Qube - Packaging';
            }
        }
    },

    async created() {
        await this.processRouteParams();

        if (this.canNotSeeProducts) {
            this.$router.push({path: '/selections'})
        }

        if (!this.canSeeArticle()) {
            this.activeTab = 1;
        }

        if (!this.canSeeArticle() && !this.canSeeDecor()) {
            this.activeTab = 2;
        }

        document.title = 'The Qube - Articles';

        EventBus.listen('set-active_product', this.setActiveProduct)
        EventBus.listen('set-active_decor', this.setActiveDecor)
        EventBus.listen('set-active_packaging', this.setActivePackaging)
        EventBus.listen('changed-active-selection', this.changedProductSelection)
    },

    destroyed() {
        EventBus.destroy('set-active_product', this.setActiveProduct)
        EventBus.destroy('set-active_decor', this.setActiveDecor)
        EventBus.destroy('set-active_packaging', this.setActivePackaging)
        EventBus.destroy('changed-active-selection', this.changedProductSelection)
    },

    computed: {},

    methods: {
        async processRouteParams() {
            const type = this.$route.params.type ?? null;
            const id = this.$route.params.item_id
                ? this.$route.params.item_id
                : this.$route.query.q ?? null;

            if (!type) {
                this.canStartLoading = true
                return;
            }

            if (type === 'product') {
                this.activeTab = 0;
                if (id) {
                    await this.setActiveProduct(id, this.activeProductSelection);
                }
            }

            if (type === 'decor') {
                this.activeTab = 1;
                if (id) {
                    await this.setActiveDecor(id, this.activeDecorSelection);
                }
            }

            if (type === 'package') {
                this.activeTab = 2;
                if (id) {
                    await this.setActivePackaging(id);
                }
            }

            this.canStartLoading = true
            EventBus.fire('loadSiteContent');
        },

        changedProductSelection(val, skipNext = false) {
            if (!this.skipNext) {
                Vue.set(this, 'activeProductSelection', val)
            } else {
                this.skipNext = false;
            }

            this.skipNext = skipNext;
        },

        reset() {
            this.selected = '';
            this.inbound = true;
            this.inactive = false;
        },

        updateBound() {
            this.inbound = !this.inbound;
            this.selected = 'bound'
            EventBus.fire('update-status', this.inbound ? 'Inbound' : 'Outbound');
        },

        updateActive() {
            this.selected = 'active'
            this.inactive = !this.inactive;
            if (this.activeTab === 0) {
                EventBus.fire('update-status', this.inactive ? 'Active' : 'Inactive');
                return;
            }

            EventBus.fire('update-isActive-decors', this.inactive);
        },

        closeProduct() {
            this.activeProduct = null;
            if (this.lastSteps[this.lastSteps.length - 2] === 'decor') {
                this.displayDecor();
                return
            }

            this.displayPackaging();
            window.location.href = `${process.env.VUE_APP_URL}/#/product`;
        },

        closeDecor() {
            this.activeDecor = null;
            this.lastSteps.pop();
            this.displayProduct();
            window.location.href = `${process.env.VUE_APP_URL}/#/decor`;
        },

        closePackaging() {
            this.activePackaging = null;
            this.lastSteps.pop();
            if (this.activeProduct) {
                this.displayProduct();
            }
            window.location.href = `${process.env.VUE_APP_URL}/#/package`;
        },

        async setActiveProduct(val, selection) {
            let response;
            if (typeof val === 'object') {
                response = await this.$dashboardStore.dispatch('getProduct', val.id);
            } else {
                response = await this.$dashboardStore.dispatch('getProduct', val);
            }
            this.activeProduct = response.data;

            this.lastSteps.push('product')
            this.displayProduct();

            this.activeProductSelection = selection;
        },

        async setActiveDecor(val, selection) {
            let response;
            if (typeof val === 'object') {
                response = await this.$dashboardStore.dispatch('getDecor', val.id);
            } else {
                response = await this.$dashboardStore.dispatch('getDecor', val);
            }

            this.activeDecor = response.data;

            this.lastSteps.push('decor')
            this.displayDecor();

            this.activeDecorSelection = selection;
        },

        async setActivePackaging(val) {
            let response;
            if (typeof val === 'object') {
                response = await this.$dashboardStore.dispatch('getPackage', val.id);
            } else {
                response = await this.$dashboardStore.dispatch('getPackage', val);
            }
            this.activePackaging = response.data;

            this.lastSteps.push('packaging')
            this.displayPackaging();
        },

        displayPackaging() {
            this.setElementVisibility('dec_detail', 'none');
            this.setElementVisibility('prod_detail', 'none');
            this.setElementVisibility('pac_detail', 'block');
        },

        displayProduct() {
            this.setElementVisibility('dec_detail', 'none');
            this.setElementVisibility('prod_detail', 'block');
            this.setElementVisibility('pac_detail', 'none');
        },

        displayDecor() {
            this.setElementVisibility('prod_detail', 'none');
            this.setElementVisibility('dec_detail', 'block');
            this.setElementVisibility('pac_detail', 'none');
        },

        setElementVisibility(element, state = 'block') {
            let domElement = document.getElementById(element);
            if (domElement) {
                domElement.style.setProperty("display", state)
            }
        },

        changeToDecors() {
            this.activeTab = 1;
            this.selected = 'active';
            this.inactive = true;
        },

        changeToProducts() {
            this.activeTab = 0;
            this.selected = 'active';
            this.inactive = true;
        }
    }
}
</script>

<style scoped>
.subnav {
    width: 1000px;
}

.menuBurger {
    height: 50px;
    width: 50px;
    background-color: var(--primary);
    color: white;
    font-size: 1.25rem;
    border-radius: 100px;
    line-height: 50px;
    grid-column: 12;
}

.actionButton {
    width: 320px;
}

.h-subnav-remain {
    height: calc(100% - 55px);
}

.camera-div {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    @apply ml-1;
}

.camera-div img {
    width: 50%;
}

.alone {
    margin-left: 54px;
}
</style>
